import { i18n } from "@lingui/core";

/**
 * Load messages for requested locale and activate it.
 * With @lingui/vite-plugin, we import .po files directly.
 */
export async function loadCatalog(locale: string) {
  const { messages } = await import(`./locales/${locale}/messages.po`);
  i18n.load(locale, messages);
  i18n.activate(locale);
}
